import { render, staticRenderFns } from "./HtmlSimpleEditor.vue?vue&type=template&id=0507054a"
import script from "./HtmlSimpleEditor.vue?vue&type=script&lang=js"
export * from "./HtmlSimpleEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports